(function () {
  "use strict";

  // Mitlaufende Produktleiste fuer Blogartikel, Stand 27.09.2026.
  // Quelle ist das bereits server-seitig gerenderte Produktmodul (.pm). Gibt es keines,
  // erscheint auch keine Leiste. Dadurch bleibt die Auswahl bei den Artikel-Metafeldern
  // und es wird nie ein unpassendes Produkt eingeblendet.

  var AB_TIEFE = 0.18;        // ab dieser Scrolltiefe einblenden
  var SCHLUESSEL = "fl_blogbar_zu";

  function geschlossen() {
    try { return sessionStorage.getItem(SCHLUESSEL) === location.pathname; } catch (e) { return false; }
  }

  function merkeGeschlossen() {
    try { sessionStorage.setItem(SCHLUESSEL, location.pathname); } catch (e) { }
  }

  function text(el) { return el ? (el.textContent || "").replace(/\s+/g, " ").trim() : ""; }

  function daten(pm) {
    var titelEl = pm.querySelector(".pm__title");
    var preisEl = pm.querySelector(".pm__price");
    var bildEl = pm.querySelector(".pm__media img");
    if (!titelEl || !titelEl.getAttribute("href")) return null;
    return {
      titel: text(titelEl),
      preis: text(preisEl),
      url: titelEl.getAttribute("href"),
      bild: bildEl ? bildEl.getAttribute("src") : ""
    };
  }

  function baue(d) {
    var bar = document.createElement("div");
    bar.className = "fl-blogbar";
    bar.setAttribute("data-fl", "blogbar");
    bar.innerHTML =
      '<a class="fl-blogbar__link" href="' + d.url + '">' +
        (d.bild ? '<img class="fl-blogbar__img" src="' + d.bild + '" alt="" width="44" height="44" loading="lazy">' : "") +
        '<span class="fl-blogbar__txt">' +
          '<span class="fl-blogbar__lbl">Passend zum Artikel</span>' +
          '<span class="fl-blogbar__name">' + d.titel + "</span>" +
        "</span>" +
        '<span class="fl-blogbar__preis">' + d.preis + "</span>" +
        '<span class="fl-blogbar__btn">Ansehen</span>' +
      "</a>" +
      '<button class="fl-blogbar__zu" type="button" aria-label="Leiste schliessen">&times;</button>';
    document.body.appendChild(bar);
    bar.querySelector(".fl-blogbar__zu").addEventListener("click", function () {
      bar.removeAttribute("data-an");
      merkeGeschlossen();
    });
    return bar;
  }

  function start() {
    if (geschlossen()) return;
    var pm = document.querySelector(".pm");
    if (!pm) return;
    var d = daten(pm);
    if (!d) return;

    var bar = baue(d);
    var an = false;

    function pruefe() {
      var doc = document.documentElement;
      var scrollbar = Math.max(doc.scrollHeight - window.innerHeight, 1);
      var tiefe = window.scrollY / scrollbar;
      // Nicht einblenden, solange das Modul selbst im Bild steht, sonst doppelt sich das Angebot.
      var r = pm.getBoundingClientRect();
      var modulSichtbar = r.top < window.innerHeight && r.bottom > 0;
      var soll = tiefe > AB_TIEFE && !modulSichtbar;
      if (soll !== an) {
        an = soll;
        if (an) bar.setAttribute("data-an", "ja");
        else bar.removeAttribute("data-an");
      }
    }

    var warte = false;
    window.addEventListener("scroll", function () {
      if (warte) return;
      warte = true;
      requestAnimationFrame(function () { warte = false; pruefe(); });
    }, { passive: true });
    pruefe();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
